export default __webpack_public_path__ + "static/media/img-34.a8efae8e.jpg";